export const LIST_COMMISSION_GROUP = 'LIST_COMMISSION_GROUP'
export const LIST_USER = 'LIST_USER'
export const UPDATE_FARE_TYPE = 'UPDATE_FARE_TYPE'
export const ROUND_OFF_LIST = 'ROUND_OFF_LIST'
